import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export interface TipoZonaLookupItem {
  id: string;
  descrizione: string;
}

@Injectable({ providedIn: 'root' })
export class TipoZonaService {
  constructor(private http: HttpClient) {}

  getTipoZone(): Observable<TipoZonaLookupItem[]> {
    return this.http.get<TipoZonaLookupItem[]>('api/lookup/tipozone');
  }
}
